/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import StringResources from '../nls/StringResources';

const ACTION_ID = 'editFilterAction';

export default class EditFilterAction {

	/**
	 * Constructor
	 *
	 * @param {Object} dashboard - Dashboard API instance
	 * @param {Object} content - Content API instance
	 * @param {Object} metadataColumn - Metadata column instance
	 * @param {string} filterId - filter id
	 */
	constructor(dashboard, content, metadataColumn, filterId) {
		this.dashboard = dashboard;
		this.content = content;
		this.metadataColumn = metadataColumn;
		this.filterId = filterId;

		this.visualization = content.getFeature('Visualization');

		this.itemContext = {
			itemId: metadataColumn.getId(),
			itemName: metadataColumn.getLabel(),
			dataType: metadataColumn.getDataType(),
			isHierarchy: metadataColumn.isHierarchy(),
			isNamedSet: metadataColumn.isNamedSet(),
			sourceId: this.visualization.getDataSource().getId()
		};

		this.renderModule = this.getEditorModuleName();
		this.toolbarContribution = [
			{
				name: 'filter',
				text: StringResources.get('toolbarActionFilter'),
				label: StringResources.get('toolbarActionFilter'),
				icon: 'common-filter',
				type: 'NextView',
				group: ACTION_ID,
				showHeading: false,
				viewModule: this.renderModule,
				viewOptions: this.getViewOptions.bind(this)
			}
		];
	}

	getActionId() {
		return ACTION_ID;
	}

	/**
	 * get the set of availableSort actions setting the selected state to match
	 * the state of the data.
	 * @returns the sort actions and their state.
	 */
	getAvailableActions() {
		return this.toolbarContribution;
	}

	getViewOptions() {
		return {
			height: 300,
			width: 212, // those are hints only; for the placement of the toolbar.
			metadataColumn: this.metadataColumn,
			logger: this.dashboard.getService(this.dashboard.GLOBAL_SERVICES.LOGGER),
			dashboardApi: this.dashboard,
			visualization: this.visualization,
			itemContext: this.itemContext,
			showBoxShadow: true // it surrounds the entire flyout not the subview
		};
	}

	/**
	 * @returns a path to the editor dialog to be loaded.
	 */
	getEditorModuleName() {
		return 'dashboard-analytics/dialogs/CommonViewWrapper';
	}

	/**
	 * Check whether the edit action is enabled or not
	 * @returns boolean - TRUE if the action is editable and FALSE if the action is not editable
	 */
	isEnabled() {
		if (!this.filterId) {
			return false;
		}
		const targetFilter = this.visualization.getLocalFilters().getFilterList()
			.find(filter => filter.id === this.filterId);
		if (!targetFilter) {
			return false;
		}
		return !targetFilter.readOnly;
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/EditFilterAction.js